function ProductDetail(props) {
  return <h1>Chi tiết sản phẩm</h1>;
}

export default ProductDetail;
